export const SA = 'S.A.';
export const LTDA = 'L.T.D.A.';
export const SPA = 'S.P.A.';
export const EIRL = 'E.I.R.L';
export const FOREINGN = 'EXTRANJERA';
export const PERSON_NATURAL = 'PERSONA_NATURAL';
export const OTHERS = 'OTRAS';
